import { http } from '../../utils';
import { CLASSTING_API_URL } from '../../constants';

export const fetchContact = ({ cid }) => http.get(`${CLASSTING_API_URL}/v1/contacts/${cid}`);

export const fetchGuardianContact = ({ gcid }) => http.get(`${CLASSTING_API_URL}/v1/guardian_contacts/${gcid}`);

export const fetchGuardianContactsByUser = () => http.get(`${CLASSTING_API_URL}/v1/guardian_contacts`);
